/**
 * DurationBar — proportional-width bar for Timeline diagnostics.
 *
 * Width scales as `ms / max` so the longest event in a service group
 * occupies ~100%. Renders as a single inline-block bar at the right
 * edge of an event row.
 *
 * Props:
 *   ms:       this event's duration
 *   maxMs:    longest duration in the group (used for proportional width)
 *   status?:  done | attention | error  (drives color)
 *   width?:   max pixel width (default 280)
 *   height?:  default 6
 */

const STATUS_COLORS = {
  done: 'rgba(104,255,154,0.85)',
  attention: 'rgba(255,179,90,0.85)',
  error: 'rgba(255,107,107,0.85)',
  skipped: 'rgba(150,150,150,0.6)',
};

export default function DurationBar({
  ms,
  maxMs,
  status = 'done',
  width = 280,
  height = 6,
}) {
  const pct = maxMs > 0 ? Math.min(1, ms / maxMs) : 0;
  const color = STATUS_COLORS[status] || STATUS_COLORS.done;
  return (
    <div
      style={{
        position: 'relative',
        width,
        height,
        background: 'var(--rd-color-panel-lo)',
        borderRadius: 'var(--rd-radius-pill)',
        overflow: 'hidden',
      }}
      aria-hidden="true"
    >
      <div
        style={{
          width: `${(pct * 100).toFixed(2)}%`,
          height: '100%',
          background: color,
          borderRadius: 'inherit',
          transition: 'width 200ms',
        }}
      />
    </div>
  );
}
